import { render } from "./Materiaal.vue?vue&type=template&id=168a2d78&scoped=true"
import script from "./Materiaal.vue?vue&type=script&lang=js"
export * from "./Materiaal.vue?vue&type=script&lang=js"

import "./Materiaal.vue?vue&type=style&index=0&id=168a2d78&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168a2d78"]])

export default __exports__